module.exports = __webpack_public_path__ + "img/visa.b1c801d3.svg";